<template>
    <div class="page-container">
        <!-- <div class="page-top">
            <img src="../assets/index-logo.png" alt="" class="logo">
        </div> -->
        <div class="page-bottom">
            <!-- 我的御粮资产 -->
            <div class="account-block">
                <div class="account-title">我的御粮资产</div>
                <div class="account-card" @click="jumpPage('account-overview')">
                    <div class="account-info">
                        <div class="account-price">{{indexData.amount}}</div>
                        <div class="account-text">御粮账户(元)</div>
                    </div>
                    <div class="btn-account">账户详情</div>
                </div>
                <!-- 战略合伙人 -->
                <div class="link-block3" v-if="userInfo.level == 4">
                    <img src="../assets/index-xsjl3.png" @click="jumpPage('sales-incentive')" alt="" class="xs-jl">
                    <div class="right-link">
                        <img src="../assets/index-tjjl3.png" @click="jumpPage('referral-reward')" alt="" class="tjjl">
                        <img src="../assets/index-zlhhr3.png" @click="jumpPage('chairman-allowance')" alt="" class="zlhhr">
                    </div>
                </div>
                <!-- 非战略合伙人 -->
                <div class="link-block2" v-else>
                    <img src="../assets/index-xsjl2.png" @click="jumpPage('sales-incentive')" alt="" class="xs-jl">
                    <img src="../assets/index-tjjl2.png" @click="jumpPage('referral-reward')" alt="" class="tjjl">
                </div>
            </div>
            <!-- 我的御粮库存 -->
            <div class="stock-block">
                <div class="stock-title" @click="jumpPage('stock-manage')">
                    <span>我的御粮库存</span> 
                    <div class="title-right">
                        <span>查看</span>
                        <van-icon name="arrow" size="18" color="#c8c8c8" />
                    </div>
                </div>
                <div v-if="userInfo.level == 5" class="account-card">
                    <div class="account-info">
                        <div class="account-price">{{indexData.inventory}}</div>
                        <div class="account-text">可提货库存(瓶)</div>
                    </div>
                    <div class="btn-account" @click="jumpPage('pickup-goods')">我要提货</div>
                </div>
                <div v-else class="stock-content">
                    <div class="stock-num">{{indexData.inventory}}</div>
                    <div class="stock-text">可提货库存(瓶)</div>
                    <div class="btn-grp">
                        <div class="btn-item" @click="jumpPage('pickup-goods')">我要提货</div>
                        <div class="btn-item" @click="jumpPage('pickup-apply')">我要进货</div>
                    </div>
                </div>
            </div>
            <!-- 我的助手 -->
            <div class="assistant">
                <div class="assistant-title">我的助手</div>
                <div class="assistant-list">
                    <div class="assistant-item item-ship" @click="jumpPage('order')">
                        <img src="../assets/index-fhgl.png" />
                        <span>发货管理</span>
                    </div>
                    <div class="assistant-item item-query" @click="jumpInvoice">
                        <img src="../assets/index-fpsq.png" />
                        <span>发票申请</span>
                    </div>
                </div>
            </div>
            <!-- 官方活动 -->
            <!-- <div class="promotion">
                <div class="promotion-title">官方活动</div>
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                    <van-swipe-item v-for="(item,index) in agentBanners" :key="index" class="swipe-item"><img class="swipe-img" :src="item.url" /></van-swipe-item>
                </van-swipe>
            </div> -->
        </div>
        <!-- 提示设置交易密码弹层 -->
        <van-dialog 
            v-model="showSetPass"
            :close-on-click-overlay=true
            title="系统提示"
            message='进货前请先去设置您的交易密码'
            confirmButtonText='去设置'
            confirmButtonColor='#3088F5'
            @confirm="normalJump('account-info')"
        >
        </van-dialog>
        <!-- 提示实名认证的弹层 -->
        <van-dialog 
            v-model="showRz"
            :close-on-click-overlay=true
            title="系统提示"
            message='您还未实名认证，快去认证吧'
            confirmButtonText='去认证'
            confirmButtonColor='#3088F5'
            @confirm="normalJump('mine')"
        >
        </van-dialog>
        <!-- 提示去签约的弹层 -->
        <van-dialog 
            v-model="showQy"
            :close-on-click-overlay=true
            title="系统提示"
            message='您还未签约，快去签约吧'
            confirmButtonText='去签约'
            confirmButtonColor='#3088F5'
            @confirm="normalJump('mine')"
        >
        </van-dialog>
        <!-- 提示去签约解锁更多功能的弹层 -->
        <van-dialog 
            v-model="showQygdgn"
            :close-on-click-overlay=true
            title="系统提示"
            message='签约成为合伙人即可解锁更多内容哦～'
            confirmButtonText='我知道了'
            confirmButtonColor='#3088F5'
        >
        </van-dialog>
        <!-- 客服弹层 -->
        <van-overlay :show="showLayer" @click="showLayer = false">
            <div class="layer-wrapper">
                <div class="layer-content" @click.stop>
                    <img src="../assets/login-icon-service.png" class="service-icon" alt="联系客服" />
                    <div class="layer-main-title">请联系客服</div>
                    <div class="service-number">4001017057</div>
                    <div class="service-time">客服工作时间9:00-18:00</div>
                    <div class="btn-group">
                        <div class="btn-cancel btn-item" @click="showLayer = false">取消</div>
                        <a href="tel:4001017057" class="btn-call btn-item">立即呼叫</a>
                    </div>
                </div>
            </div>
        </van-overlay>

    </div>
</template>

<script>
import {Overlay,Icon,Swipe,SwipeItem,Dialog,Toast} from 'vant'

import $http from '../lib/request'
import config from '../config'
import { getLocalUserInfo,setLocalUserInfo } from '@/lib/util'

export default {
    data(){
        return {
            totalStockSee:true,
            indexData:{
                allowanceAmount: 0,//会长津贴
                amount: 0,//账户余额
                inventory: 0,//可提货库存
                recommendAmount: 0,//推荐奖励余额
                saleTotal: 0,//销售奖励
            },
            showQy:false,//去签约提示弹层
            showRz:false,//实名认证弹层是否显示
            showQygdgn:false,//去签约解锁更多功能的弹层
            userInfo:{},
            showLayer:false,//是否展示客服弹层
            showSetPass:false,//展示提示设置交易密码弹层
        }
    },
    activated(){
        this.checkuData();

        let uInfo=getLocalUserInfo();
        if(uInfo){
            this.userInfo=uInfo;
            if(uInfo.status == 2 && uInfo.level != 5){
                this.showRz=true;
                return;
            }
            if((uInfo.status == 7 || uInfo.status == 8) && uInfo.level != 5){
                this.showQy=true;
            }
        }
        $http({
            method:'post',
            url:config.api.index
        }).then(res=>{
            if(res.errno == 0){
                this.indexData=res.data;
            }else{
                Toast(res.errno);
            }
        })
    },
    components:{
        [Icon.name]:Icon,
        [Swipe.name]:Swipe,
        [SwipeItem.name]:SwipeItem,
        [Dialog.Component.name]:Dialog.Component,
        [Toast.name]:Toast,
        [Overlay.name]:Overlay
    },
    methods:{
        checkuData(){//获取最新用户信息
            $http({
                method:'post',
                url:config.api.checkUserData
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        toggleSee(){
            this.totalStockSee=!this.totalStockSee;
        },
        jumpPage(name){
            if(this.userInfo.status == 9){
                Dialog({
                    closeOnClickOverlay:true,
                    title:"系统提示",
                    message:'财务正在对您的订货款进行审核<br/>入账后可立即进货',
                    confirmButtonText:'我知道了',
                    confirmButtonColor:'#3088F5',
                });
                return;
            }
            if(this.userInfo.status != 1 && (name == 'account-overview' || name == 'sales-incentive')){
                this.showQygdgn=true;
                return;
            }
            // if(name == 'pickup-apply' && this.userInfo.jypwd != 1 && this.userInfo.status == 1){
            //     this.showSetPass=true;
            //     return;
            // }
            if(name == 'pickup-goods'){
                if(this.indexData.inventory <= 0){
                    Toast('当前可提货库存为0');
                    return;
                }
            }
            this.$router.push({
                name:name
            });
        },
        normalJump(name){
            this.$router.push({
                name:name
            });
        },
        jumpInvoice(){
            if(this.userInfo.status == 1){
                this.showLayer=true;
                return;
            }else{
                this.showQygdgn=true;
                return;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    background:#fff;
    min-height: calc(100vh - 46px);
    .page-top{
        box-sizing: border-box;
        background: linear-gradient(310deg, #3CA7FE 0%, #3088F5 100%);
        color:#fff;
        padding:8px 0;
        .logo{
            width:63px;
            height:27px;
            display: block;
            margin:0 auto;
        }
    }
    .page-bottom{
        padding:15px;
        .account-block{
            .account-title{
                color:#333;
                font-size: 16px;
                font-weight: 500;
                line-height: 22px;
                margin-bottom: 10px;
            }
            .account-card{
                @include flex-between();
                height:100px;
                box-sizing: border-box;
                padding:21px 30px 21px 30px;
                background: linear-gradient(310deg, #3CA7FE 0%, #3088F5 100%);
                border-radius: 4px;
                margin-bottom: 15px;
                .account-info{
                    color:#fff;
                    .account-price{
                        line-height: 35px;
                        font-size: 30px;
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        margin-bottom: 5px;
                    }
                    .account-text{
                        font-size: 13px;
                        line-height: 18px;
                        color: rgba(255,255,255,0.7);
                    }
                }
                .btn-account{
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 6px -2px #2277E1;
                    border-radius: 26px;
                    font-size: 14px;
                    color:#3088F5;
                }
            }
            .link-block2{
                @include flex-between();
                margin-bottom: 25px;
                &>img{
                    width:166px;
                    height:58px;
                }
            }
            .link-block3{
                @include flex-between();
                margin-bottom: 25px;
                .xs-jl{
                    width:132px;
                    height:126px;
                }
                .right-link{
                    height:126px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    &>img{
                        width:200px;
                        height:58px;
                    }
                }
            }
        }
        .stock-block{
            margin-bottom: 25px;
            .stock-title{
                @include flex-between();
                color:#333;
                font-size: 16px;
                font-weight: 500;
                line-height: 22px;
                margin-bottom: 10px;
                .title-right{
                    display: flex;
                    align-items: center;
                    &>span{
                        color:#3088F5;
                        font-size: 14px;
                        margin-right: 6px;
                    }
                }
            }
            .account-card{
                @include flex-between();
                height:100px;
                box-sizing: border-box;
                padding:21px 30px 21px 30px;
                border-radius: 4px;
                background: #FFFFFF;
                box-shadow: 0px 2px 21px -6px rgba(200, 200, 200, 0.5);
                border-radius: 4px;
                .account-info{
                    .account-price{
                        line-height: 35px;
                        font-size: 30px;
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        margin-bottom: 5px;
                        color:#3088F5;
                    }
                    .account-text{
                        font-size: 13px;
                        line-height: 18px;
                        color: #333;
                    }
                }
                .btn-account{
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    border-radius: 26px;
                    font-size: 14px;
                    color:#fff;
                    background: linear-gradient(90deg, #3088F5 0%, #5AB9FB 100%);
                    box-shadow: 0px 0px 6px -2px #CCCCCC;
                }
            }
            .stock-content{
                background: #FFFFFF;
                box-shadow: 0px 2px 21px -6px rgba(200, 200, 200, 0.5);
                border-radius: 4px;
                box-sizing: border-box;
                padding:15px;
                text-align: center;
                .stock-num{
                    font-size: 30px;
                    line-height: 35px;
                    color:#3088F5;
                    margin-bottom: 5px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                }
                .stock-text{
                    font-size: 13px;
                    color:#333;
                    line-height: 18px;
                    margin-bottom: 16px;
                }
                .btn-grp{
                    @include flex-between();
                    background:#f8f9fd;
                    height:44px;
                    .btn-item{
                        width:50%;
                        box-sizing: border-box;
                        text-align: center;
                        font-size: 14px;
                        line-height: 20px;
                        color:#3088F5;
                        &:first-child{
                            border-right: 1px solid #e0e0e0;
                        }
                    }
                }
            }
        }
        .assistant{
            margin-bottom: 20px;
            .assistant-title{
                color:#333;
                font-size: 16px;
                font-weight: 500;
                line-height: 22px;
                margin-bottom: 10px;
            }
            .assistant-list{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .assistant-item{
                    width:162px;
                    height:72px;
                    box-sizing: border-box;
                    padding:18px 15px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 10px 0px rgba(220, 220, 220, 0.5);
                    @media screen and (max-width: 750px){
                        border-radius: 6px;
                    }
                    &>img{
                        width:36px;
                        height:36px;
                        margin-right: 13px;
                    }
                    &>span{
                        font-size: 16px;
                        color:#333;
                    }
                }
            }
        }
        .promotion{
            .promotion-title{
                color:#333;
                margin-bottom: 10px;
                font-size: 14px;
                line-height: 20px;
            }
            .my-swipe{
                .swipe-item{
                    width:100%;
                    color: #fff;
                    font-size: 20px;
                    line-height: 150px;
                    text-align: center;
                    .swipe-img{
                        width:100%;
                        display:block;
                    }
                }
            }
        }
    }
    //客服弹层
    .layer-wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        height:100%;
    }
    .layer-content{
        width: 316px;
        box-sizing: border-box;
        padding:20px;
        background:#fff;
        border-radius: 6px;
        text-align: center;
        .service-icon{
            width:90px;
            height:84px;
            margin:8px auto;
            display: block;
        }
        .layer-main-title{
            color:#333;
            font-size: 14px;
            line-height: 20px;
        }
        .service-number{
            color:#333;
            font-weight: 500;
            margin:4px 0;
            font-size: 18px;
            line-height: 26px;
        }
        .service-time{
            color:#3088f5;
            font-size: 14px;
            line-height: 18px;
        }
        .btn-group{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 26px;
            .btn-item{
                width:132px;
                height:40px;
                line-height: 40px;
                border-radius: 26px;
                font-size: 16px;
                &.btn-cancel{
                    border:1px solid #e7e7e7;
                }
                &.btn-call{
                    background: linear-gradient(296deg, #5EBDFB 0%, #3088F5 100%);
                    color: #fff;
                }
            }
        }
    }
}
</style>